import type { Node, Edge } from '@xyflow/react'
import { SERVICE_TYPE, STATUS, ZONE } from '@/enums'

export const _zones = [
  { id: ZONE.US, name: 'United States', status: 'operational', services: 7 },
  { id: ZONE.EU, name: 'Europe', status: 'operational', services: 6 },
  { id: ZONE.SEA, name: 'Southeast Asia', status: 'degraded', services: 5 },
]

export interface IZoneStatus {
  status: STATUS
}

export type TServiceData = {
  name: string
  description: string
  type: SERVICE_TYPE
  status: STATUS
  uptime: number
  responseTime: number
  zones: Record<ZONE, IZoneStatus>
  dependencies: string[]
}

export const _serviceNodes: Node<TServiceData>[] = [
  {
    id: 'celestia-cosmos',
    position: { x: 300, y: 20 },
    type: 'defaultService',
    data: {
      name: 'Celestia Cosmos',
      description: 'Main TheIceJi WebApp',
      type: SERVICE_TYPE.WEB_APP,
      status: STATUS.OPERATIONAL,
      uptime: 100,
      responseTime: 45,
      zones: {
        [ZONE.US]: { status: STATUS.OPERATIONAL },
        [ZONE.EU]: { status: STATUS.MAINTENANCE },
        [ZONE.SEA]: {
          status: STATUS.OPERATIONAL,
        },
      },
      dependencies: [],
    },
  },
  {
    id: 'celestia-nebula',
    position: { x: 20, y: 20 },
    type: 'defaultService',
    data: {
      name: 'Celestia Nebula',
      description: 'Monitoring and Management',
      type: SERVICE_TYPE.WEB_APP,
      status: STATUS.OPERATIONAL,
      uptime: 100,
      responseTime: 45,
      zones: {
        [ZONE.US]: { status: STATUS.OPERATIONAL },
        [ZONE.EU]: { status: STATUS.MAINTENANCE },
        [ZONE.SEA]: {
          status: STATUS.OPERATIONAL,
        },
      },
      dependencies: [],
    },
  },
  {
    id: 'celestia-outpost',
    position: { x: 580, y: 20 },
    type: 'defaultService',
    data: {
      name: 'Celestia Outpost',
      description: 'Client works and projects',
      type: SERVICE_TYPE.WEB_APP,
      status: STATUS.OPERATIONAL,
      uptime: 100,
      responseTime: 45,
      zones: {
        [ZONE.US]: { status: STATUS.OPERATIONAL },
        [ZONE.EU]: { status: STATUS.OPERATIONAL },
        [ZONE.SEA]: {
          status: STATUS.OPERATIONAL,
        },
      },
      dependencies: [],
    },
  },
  {
    id: 'celestia-stargate',
    position: { x: 20, y: 200 },
    type: 'defaultService',
    data: {
      name: 'Celestia Stargate',
      description: 'Authentication, SSO, OAuth/Web3 auth',
      type: SERVICE_TYPE.SERVICE,
      status: STATUS.OPERATIONAL,
      uptime: 100,
      responseTime: 23,
      zones: {
        [ZONE.US]: { status: STATUS.OPERATIONAL },
        [ZONE.EU]: { status: STATUS.MAINTENANCE },
        [ZONE.SEA]: {
          status: STATUS.OPERATIONAL,
        },
      },
      dependencies: ['user-db'],
    },
  },
  {
    id: 'celestia-stella',
    position: { x: 560, y: 200 },
    type: 'defaultService',
    data: {
      name: 'Celestia Stella',
      description: 'Main server',
      type: SERVICE_TYPE.SERVICE,
      status: STATUS.OPERATIONAL,
      uptime: 100,
      responseTime: 23,
      zones: {
        [ZONE.US]: { status: STATUS.OPERATIONAL },
        [ZONE.EU]: { status: STATUS.MAINTENANCE },
        [ZONE.SEA]: {
          status: STATUS.OPERATIONAL,
        },
      },
      dependencies: ['user-db'],
    },
  },
  // {
  //   id: 'user-service',
  //   position: { x: 300, y: 250 },
  //   type: 'defaultService',
  //   data: {
  //     name: 'User Service',
  //     description: 'User management and profiles',
  //     type: 'service',
  //     status: STATUS.DEGRADED,
  //     uptime: 99.85,
  //     responseTime: 120,
  //     zones: {
  //       [ZONE.US]: { status: STATUS.OPERATIONAL },
  //       [ZONE.EU]: { status: STATUS.MAINTENANCE },
  //       [ZONE.SEA]: {
  //         status: STATUS.OPERATIONAL,
  //       },
  //     },
  //     dependencies: ['user-db', 'cache-redis'],
  //   },
  // },
  // {
  //   id: 'payment-service',
  //   position: { x: 500, y: 250 },
  //   type: 'defaultService',
  //   data: {
  //     name: 'Payment Service',
  //     description: 'Payment processing',
  //     type: 'service',
  //     status: STATUS.OPERATIONAL,
  //     uptime: 99.95,
  //     responseTime: 67,
  //     zones: {
  //       [ZONE.US]: { status: STATUS.OPERATIONAL },
  //       [ZONE.EU]: { status: STATUS.MAINTENANCE },
  //       [ZONE.SEA]: {
  //         status: STATUS.OPERATIONAL,
  //       },
  //     },
  //     dependencies: ['payment-db'],
  //   },
  // },
  // {
  //   id: 'user-db',
  //   position: { x: 150, y: 400 },
  //   type: 'defaultService',
  //   data: {
  //     name: 'User Database',
  //     description: 'Primary user data storage',
  //     type: 'database',
  //     status: STATUS.OPERATIONAL,
  //     uptime: 99.98,
  //     responseTime: 15,
  //     zones: {
  //       [ZONE.US]: { status: STATUS.OPERATIONAL },
  //       [ZONE.EU]: { status: STATUS.MAINTENANCE },
  //       [ZONE.SEA]: {
  //         status: STATUS.OPERATIONAL,
  //       },
  //     },
  //     dependencies: [],
  //   },
  // },
  // {
  //   id: 'payment-db',
  //   position: { x: 450, y: 400 },
  //   type: 'defaultService',
  //   data: {
  //     name: 'Payment Database',
  //     description: 'Payment data storage',
  //     type: 'database',
  //     status: STATUS.OPERATIONAL,
  //     uptime: 99.96,
  //     responseTime: 12,
  //     zones: {
  //       [ZONE.US]: { status: STATUS.OPERATIONAL },
  //       [ZONE.EU]: { status: STATUS.MAINTENANCE },
  //       [ZONE.SEA]: {
  //         status: STATUS.OPERATIONAL,
  //       },
  //     },
  //     dependencies: [],
  //   },
  // },
  {
    id: 'cache-redis',
    position: { x: 860, y: 60 },
    type: 'defaultService',
    data: {
      name: 'Redis Cache',
      description: 'In-memory caching layer',
      type: SERVICE_TYPE.CACHE,
      status: STATUS.OPERATIONAL,
      uptime: 100,
      responseTime: 5,
      zones: {
        [ZONE.US]: { status: STATUS.OPERATIONAL },
        [ZONE.EU]: { status: STATUS.MAINTENANCE },
        [ZONE.SEA]: {
          status: STATUS.OPERATIONAL,
        },
      },
      dependencies: [],
    },
  },
  {
    id: 'celestia-orion',
    position: { x: 860, y: 240 },
    type: 'defaultService',
    data: {
      name: 'Celestia Orion',
      description: 'Asset and data storage center',
      type: SERVICE_TYPE.CACHE,
      status: STATUS.OPERATIONAL,
      uptime: 100,
      responseTime: 5,
      zones: {
        [ZONE.US]: { status: STATUS.OPERATIONAL },
        [ZONE.EU]: { status: STATUS.MAINTENANCE },
        [ZONE.SEA]: {
          status: STATUS.OPERATIONAL,
        },
      },
      dependencies: [],
    },
  },
]

export const _serviceEdges: Edge[] = [
  {
    id: 'cosmos-stargate',
    target: 'celestia-cosmos',
    source: 'celestia-stargate',
    style: { stroke: 'hsl(var(--health-operational))', strokeWidth: 2 },
  },
  {
    id: 'redis-stella',
    source: 'cache-redis',
    target: 'celestia-stella',
    animated: true,
    style: { stroke: 'hsl(var(--health-operational))', strokeWidth: 2 },
  },
  {
    id: 'orion-stella',
    source: 'celestia-orion',
    target: 'celestia-stella',
    animated: true,
    style: { stroke: 'hsl(var(--health-operational))', strokeWidth: 2 },
  },
]
